export default [
  {
    path: '/admin/product-price-schema',
    name: 'product-price-schema',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/restaurant-sale/product-price-schema/index.vue')
  },
  {
    path: '/admin/product-price-schema/create',
    name: 'product-price-schema-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/restaurant-sale/product-price-schema/create')
  },
]
